var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "等级续期",
            visible: _vm.isShowTime,
            width: "950px",
            "before-close": _vm.TimeClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "当前等级到期时间:", prop: "" } },
                [_c("div", [_vm._v(_vm._s(_vm.gradeInvalidTime))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选择续期时长:", prop: "duration" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("7天")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("14天")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("1个月")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "3" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("3个月")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "4" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("6个月")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "5" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("1年")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "6" },
                      model: {
                        value: _vm.ruleForm.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "duration", $$v)
                        },
                        expression: "ruleForm.duration",
                      },
                    },
                    [_vm._v("永久")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "修改原因:", prop: "reason" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "600px" },
                    attrs: { placeholder: "输入原因" },
                    model: {
                      value: _vm.ruleForm.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "reason", $$v)
                      },
                      expression: "ruleForm.reason",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        color: "#f59a23",
                        "font-weight": "400",
                      },
                    },
                    [
                      _vm._v(
                        "修改后,将在原有有效时间上累加选定的时长（若原本为永久，则不能增加时长）"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.TimeClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }